export var types = [{
  name: "Four or more years",
  abbreviation: "92b0031d-2e00-44a8-9698-0e7ced04d23c"
}, {
  name: "At least 2, but less than 4 years",
  abbreviation: "a61d8ab2-55fb-4464-a5b6-ad1b5e947ea5"
}, {
  name: "Less than 2 years (below associate)",
  abbreviation: "635e6ffc-7c73-4cc4-9f13-774c927f65a0"
}];